import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartComponent } from './chart/chart.component';
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";



@NgModule({
    declarations: [
        ChartComponent
    ],
    exports: [
        ChartComponent
    ],
    imports: [
        CommonModule,
        MatButton,
        MatIcon
    ]
})
export class ChartBoxModule { }
